import jwtAuthAxios from "services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const withAuth = () => {
    const token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
};

// Ringkasan pembayaran mahasiswa (total tagihan, terbayar, sisa, biaya wajib 1 semester).
export const getRingkasanByNim = createAsyncThunk("pembayaranBaru/getRingkasanByNim", async (nim) => {
    withAuth();
    const response = await jwtAuthAxios.get(`v1/pembayaran/ringkasan-nim/${nim}`);
    return response.data;
});

// Daftar tagihan mahasiswa (per tipe/semester) beserta status BELUM_BAYAR/PARTIAL/LUNAS.
export const getTagihanByNim = createAsyncThunk("pembayaranBaru/getTagihanByNim", async (nim) => {
    withAuth();
    const response = await jwtAuthAxios.get(`v1/tagihan-mahasiswa/nim/${nim}`);
    return response.data;
});

// Riwayat transaksi/angsuran mahasiswa.
export const getTransaksiByNim = createAsyncThunk("pembayaranBaru/getTransaksiByNim", async (nim) => {
    withAuth();
    const response = await jwtAuthAxios.get(`v1/transaksi-pembayaran/mahasiswa-nim/${nim}`);
    return response.data;
});

// Bayar sebuah tagihan (boleh sebagian/cicilan). payload: { tagihan_id, nominal, gateway, bank_code }
export const bayarTagihan = createAsyncThunk("pembayaranBaru/bayarTagihan", async (payload, { rejectWithValue }) => {
    try {
        withAuth();
        const response = await jwtAuthAxios.post(`v1/pembayaran/bayar`, payload);
        return response.data;
    } catch (err) {
        return rejectWithValue(err?.response?.data || { message: err.message });
    }
});

const initialState = {
    loadingRingkasan: false,
    loadingTagihan: false,
    loadingTransaksi: false,
    loadingBayar: false,
    dataRingkasan: {},
    dataTagihan: [],
    dataTransaksi: [],
    resultBayar: null,
};

const pembayaranBaruSlice = createSlice({
    name: "pembayaranBaru",
    initialState,
    reducers: {
        resetResultBayar: (state) => {
            state.resultBayar = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getRingkasanByNim.pending, (state) => { state.loadingRingkasan = true; })
            .addCase(getRingkasanByNim.fulfilled, (state, action) => {
                state.dataRingkasan = action.payload?.data || {};
                state.loadingRingkasan = false;
            })
            .addCase(getRingkasanByNim.rejected, (state) => { state.loadingRingkasan = false; });

        builder
            .addCase(getTagihanByNim.pending, (state) => { state.loadingTagihan = true; })
            .addCase(getTagihanByNim.fulfilled, (state, action) => {
                state.dataTagihan = Array.isArray(action.payload) ? action.payload : [];
                state.loadingTagihan = false;
            })
            .addCase(getTagihanByNim.rejected, (state) => { state.loadingTagihan = false; });

        builder
            .addCase(getTransaksiByNim.pending, (state) => { state.loadingTransaksi = true; })
            .addCase(getTransaksiByNim.fulfilled, (state, action) => {
                state.dataTransaksi = Array.isArray(action.payload) ? action.payload : [];
                state.loadingTransaksi = false;
            })
            .addCase(getTransaksiByNim.rejected, (state) => { state.loadingTransaksi = false; });

        builder
            .addCase(bayarTagihan.pending, (state) => { state.loadingBayar = true; })
            .addCase(bayarTagihan.fulfilled, (state, action) => {
                state.resultBayar = action.payload?.data || action.payload;
                state.loadingBayar = false;
            })
            .addCase(bayarTagihan.rejected, (state) => { state.loadingBayar = false; });
    },
});

export const { resetResultBayar } = pembayaranBaruSlice.actions;
export const pembayaranBaruSelector = (state) => state.pembayaranBaru;
export default pembayaranBaruSlice.reducer;
